import { Box, HStack, Text } from '@chakra-ui/react';
import { ExternalLinkIcon } from 'components/Avatar/ExternalLinkIcon';
import { AppLink } from './AppLink';

export function ResetPasswordOnProviderLink({
  href,
  provider,
}: {
  href?: string;
  provider: string;
}): JSX.Element | null {
  if (!href) {
    return null;
  }

  return (
    <HStack justify="flex-end">
      <AppLink
        fontSize="sm"
        fontWeight="500"
        href={href}
        target="_blank"
        rel="noreferrer"
        minW="0"
      >
        <Text textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
          Reset password on {provider}
        </Text>
      </AppLink>

      <ExternalLinkIcon />
    </HStack>
  );
}
